<template>
  <v-container>
    <h1>Modi di utilizzo</h1>
    <div class="text-content">
      <v-row>
        <v-col>
          <div>
            <p>
              Al momento si può utilizzare <b>EduKanji</b> come: <br>
            <ol>
              <li>Modulo per Moodle</li>
              <li>Indicando direttamente il kanji nella url</li>
            </ol>
            </p>
            <section>
              1. Per usare <b> EduKanji</b> in Moodle:<br>
              <div>
                <ul>
                  <li>
                    Creare un nuovo modulo Moodle "Url" e configurarlo come segue
                  </li>
                  <li>
                    Sezione "Generale"

                    <ol>
                      <li>"Nome": inserire il nome della lezione</li>
                      <li>
                        "URL": inserire il seguente URL:
                        <b class="theurl">https://edukanji.unive.it/kanji/{carattere}</b><br />Esempio:<br>
                        <a href='https://edukanji.unive.it/kanji/川'
                          target="_blank">https://edukanji.unive.it/kanji/川</a>
                      </li>
                    </ol>
                  </li>
                  <li>
                    Sezione "Aspetto", menu "Visualizzazione": opzione [Incorpora]
                  </li>
                </ul>
              </div>
            </section>

            <section>
              2. Per usare <b>EduKanji</b> direttamente:
              <div>
                <ul>
                  <li>Digitare nel browser il seguente URL:<br>
                    <b class="theurl">https://edukanji.unive.it/kanji/{carattere}</b><br />Esempio:<br><a
                      href='https://edukanji.unive.it/kanji/川' target="_blank">https://edukanji.unive.it/kanji/川</a>
                  </li>
                  <li>
                    <b class="theurl">https://edukanji.unive.it/kana/{carattere}</b><br />Esempio:<br><a
                      href='https://edukanji.unive.it/kana/か' target="_blank">https://edukanji.unive.it/kana/か</a>
<br><a
                      href='https://edukanji.unive.it/kana/ホ' target="_blank">https://edukanji.unive.it/kana/ホ</a>
                  </li>
                </ul>

              </div>
            </section>


          </div>
        </v-col>
        <v-col>
          <img style='min-width:300px' src="@/assets/edukanji-demo.png" class="kanji-img" alt="Schermata dimostrativa di Edukanji" />
        </v-col>
      </v-row>
    </div>

  </v-container>
</template>

<script>

export default {

}
</script>

<style scoped>
.kanji-img {

  max-width: 400px;
  width: 100%;

}

.theurl {
  font-size: smaller;
}
</style>